<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/balancing_payment";
import {serialize} from "object-to-formdata";

export default {
  extends: ModelCreateModal,
  props: {
    modalTitle: {
      default() {
        return this.lodash.startCase(this.$t('balancing_payments.singular'))
      }
    },
    resourceRoute: {default: 'balancing_payments'},
    modelVariable: {default: 'balancing_payment'},
    form: {
      default() {
        return FormsModel;
      }
    }
  },
  watch: {
    initialValue: function (newData) {
      this.model = {
        ...this.model,
        ...newData
      }
    }
  },
  methods: {
    requestPayload({
                     ticket_id,
                     from_bank_account_id,
                     to_bank_account_id,
                     invoice_number,
                     paid_at,
                     credit,
                     description,
                     balancing,
                   }) {
      return {
        ticket_id,
        from_bank_account_id,
        to_bank_account_id,
        invoice_number,
        paid_at,
        credit,
        description,
        balancing: {
          id: balancing.id
        },
        balancing_transaction: {
            id: balancing.id,
            adjustment: balancing.adjustment,
        }
      }
    },
    store({...value}) {
      const payload = this.requestPayload(value);
      payload.files = [];
      const {transfer_slip, invoice_document} = value;
      if (transfer_slip?.file) {
        payload.files.push({name: 'transfer slip', path: transfer_slip.file})
      }
      if (invoice_document?.file) {
        payload.files.push({name: 'invoice document', path: invoice_document.file})
      }
      if (value.optional_files) {
        const optional_files = value.optional_files?.filter(v => v.file).map(v => ({path: v.file, name: 'optional file'}));
        payload.files = [...payload.files, ...optional_files];
      }
      return this.$axios.post(`/balancing_transactions/${value.balancing.id}/payments`, (
          serialize({...payload}, {indices: true, booleansAsIntegers: true})
      ))
    },
    handleStore({...value}) {
      this.store(value).then(({data: {data}}) => {
        this.$toast("Perubahan berhasil disimpan", {
          type: "success",
          timeout: 10000,
          position: "bottom-left",
        });
        this.$emit('created', data)
        this.initialValue = {};
        this.model = {};
        this.$refs.modal.hide();
      }).catch((error) => this.failedAlert(error))
    },
    open(initialValue = {}) {
      this.initialValue = initialValue,
          this.$bvModal.show('balancing-payment-create-modal');
    }
  },
}
</script>
<style scoped lang="scss">
::v-deep {
  .modal-dialog {
    max-width: 720px !important;
  }
}
</style>